export interface CommercialPaymentRoute {
  payment_mode_id: number;
  treasury_account_id: number;
  currency_id?: number;
  company_currency_id?: number;
}

export const getSuggestedTreasuryAccountId = (
  paymentModeId: unknown,
  routes: CommercialPaymentRoute[],
  accounts: Array<{ id: number | string }>,
): number | undefined => {
  const modeId = Number(paymentModeId);
  if (!Number.isInteger(modeId) || modeId <= 0) return undefined;

  const route = routes.find(
    (item) => Number(item.payment_mode_id) === modeId,
  );
  if (!route) return undefined;

  const accountId = Number(route.treasury_account_id);
  return accounts.some((account) => Number(account.id) === accountId)
    ? accountId
    : undefined;
};
